import types from './actionTypes';

export const partnersRequest = () => ({
    type: types.PARTNERS_REQUEST,
});

export const partnersRequestCompleted = () => ({
    type: types.PARTNERS_REQUEST_COMPLETED,
});

export const updatePartnersRequest = (form, payload) => ({
    type: types.UPDATE_PARTNERS_REQUEST,
    meta: {
        form,
    },
    payload,
});
